import React from 'react';

interface ErrorPageProps {
  message: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ message }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-white text-2xl">✗</span>
        </div>
        <h1 className="text-2xl font-bold text-red-600 mb-4">Verification Failed</h1>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default ErrorPage; 